import { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'

const AssignModal = ({
  tab: tabInitValue = 0,
  resourceName = '',
  active = false,
  students = [],
  classrooms = [],
  onClose,
  onSubmitStudents = () => {},
  onSubmitClassrooms = () => {},
}) => {
  const [tab, setTab] = useState(0)

  const [selectedStudents, setSelectedStudents] = useState({})
  const [selectedClassrooms, setSelectedClassrooms] = useState({})

  const [startDate, setStartDate] = useState(new Date())
  const [finishDate, setFinishDate] = useState(new Date())

  useEffect(() => {
    setTab(tabInitValue)
  }, [tabInitValue])

  const handleStudentCheck = (id) => (val) => {
    const values = {
      ...selectedStudents,
      [id]: selectedStudents[id] ? undefined : true,
    }
    setSelectedStudents(values)
  }

  const handleClassroomCheck = (id) => (val) => {
    const values = {
      ...selectedClassrooms,
      [id]: selectedClassrooms[id] ? undefined : true,
    }
    setSelectedClassrooms(values)
  }

  const handleSubmit = (event) => {
    event.preventDefault()

    console.log('onSubmitStudents', onSubmitStudents)

    if (tab === 0) {
      const ids = Object.keys(selectedStudents).filter(
        (key) => selectedStudents[key],
      )
      onSubmitStudents({ ids, startDate, finishDate })
    } else {
      const ids = Object.keys(selectedClassrooms).filter(
        (key) => selectedClassrooms[key],
      )
      onSubmitClassrooms({ ids, startDate, finishDate })
    }
  }

  return (
    <>
      <div className={`mask mask ${active ? 'show' : ''}`} />

      <div className={`modals ${active ? 'active' : ''}`}>
        <div className="modals__wrapper">
          <div className="modal modal-assign purchaseHb">
            <div className="wrapper">
              <div className="modal-wrap">
                <div className="modal-assign__top">
                  <span className="modal-assign__title">
                    Assign this {resourceName} to
                  </span>
                  <div className="searchHb">
                    <div className="input-block">
                      <i className="hb-ico search-ico" />
                      <input type="text" name="search" placeholder="Search" />
                    </div>
                  </div>
                </div>
                <form
                  onSubmit={handleSubmit}
                  action="/"
                  className="detail__form detail__form--reviews"
                  name="reviewsForm"
                >
                  <div className="allTabs">
                    <ul className="tab-list assign-menu">
                      <li>
                        <a
                          onClick={() => {
                            setTab(0)
                          }}
                          href="#"
                          className={`${tab === 0 ? 'active' : ''}`}
                        >
                          Student
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={() => {
                            setTab(1)
                          }}
                          href="#"
                          className={`${tab === 1 ? 'active' : ''}`}
                        >
                          Class
                        </a>
                      </li>
                    </ul>
                    <div className={`tab ${tab === 0 ? 'tab-active' : ''}`}>
                      <div className="assign-list">
                        {students.map((item, i) => (
                          <div key={item.id} className="assign-item">
                            <div className="checkbox">
                              <input
                                onChange={handleStudentCheck(item.id)}
                                checked={Boolean(selectedStudents[item.id])}
                                type="checkbox"
                                className="checkbox"
                                name={item.id}
                                id={item.id}
                              />
                              <i className="checkbox-ico" />
                            </div>
                            <div className="assign-num">{i + 1}</div>
                            <div className="assign-users">
                              <div className="assign-user">
                                <img
                                  src={
                                    item.avatar ||
                                    '/account/img/options-user.jpg'
                                  }
                                  alt=""
                                />
                              </div>
                              <span className="assign-name">
                                {item.first_name} {item.last_name}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className={`tab ${tab === 1 ? 'tab-active' : ''}`}>
                      <div className="assign-list">
                        {classrooms.map((item, i) => (
                          <div key={item.id} className="assign-item">
                            <div className="checkbox">
                              <input
                                onChange={handleClassroomCheck(item.id)}
                                checked={Boolean(selectedClassrooms[item.id])}
                                type="checkbox"
                                className="checkbox"
                                name={item.id}
                                id={item.id}
                              />
                              <i className="checkbox-ico" />
                            </div>
                            <div
                              className={`assign-num assign-num__white bg_color__${item.color}`}
                            >
                              {item?.grade?.name.replace('Kindergarten', 'K')}
                            </div>
                            <div className="assign-text">{item.name}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-2">
                      <label>Start:</label>
                    </div>
                    <div className="col-10">
                      <div className="input-block">
                        <DatePicker
                          showTimeSelect
                          dateFormat="MMMM d, yyyy h:mm aa"
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                        />
                      </div>
                    </div>
                    <div className="col-2">
                      <label>Finish:</label>
                    </div>
                    <div className="col-10">
                      <div className="input-block">
                        <DatePicker
                          showTimeSelect
                          dateFormat="MMMM d, yyyy h:mm aa"
                          selected={finishDate}
                          onChange={(date) => setFinishDate(date)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="buttons-row">
                    <a onClick={onClose} href="#" className="second-btn">
                      Cancel
                    </a>
                    <button type="submit" className="primary-btn">
                      Assign
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AssignModal
